<template>
	<div>
		<headinfo></headinfo>
		<!--中间内容-->
		<div class="center container">
			<div class="center-nav">
				<span class="hidden-xs">您的位置：</span>
				<router-link :to="{name:'home'}">首页</router-link><i>&gt;</i>
				<a title="最新咨询" href="#">最新咨询</a>
			</div>
			<div class="center-container">
				<div class="center-container-left">
					<div class="center-container-left-Ltitle">
						<ul>
							<li>
								<a class="active" title="最新咨询">最新咨询</a>
							</li>
						</ul>
						<div class="left-pic">
							<img src="./../assets/img/left-pic.png" alt="">
						</div>
					</div>
				</div>
				<!-- 最新咨询 -->
				<div class="center-container-right" v-if="pages=='1'">
					<div class="center-container-right-title">
						<span class="title">最新咨询</span>
					</div>
					<div class="center-container-right-words">
						<ul>
							<li v-for="(item,index) in tabledata" :key="index"  
							style="width:90%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
								<span class="gzdt-time">[{{item.state == '1'?'已回复':'未回复'}}]</span>
								<a  style="cursor:pointer;"@click="openzx(item)">{{item.content}}</a>
							</li>
						</ul>
						<div class="pagearea">
							<div id="kkpager">
								<div>
									<span>共{{total}}条记录 第{{query.pageNum}}页</span> &nbsp;
									<a disabled="disabled" @click="openpagesize(1)">首页</a>
									<a disabled="disabled" @click="openpagesize(2)">上一页</a>&nbsp;
									<a disabled="disabled" @click="openpagesize(3)">下一页</a>
									<a disabled="disabled" @click="openpagesize(4)">尾页</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<el-dialog title="公证员回复" :visible.sync="open" width="40%" :show-close="false" v-if="zxdata">
				<el-descriptions class="margin-top" title="" :column="2" border>
					<el-descriptions-item labelStyle="width:100px;min-width: 100px;text-align: center;">
						<template slot="label">
							<i class="el-icon-user"></i>
							咨询人
						</template>
						****
					</el-descriptions-item>
					<el-descriptions-item labelStyle="width:100px;min-width: 100px;text-align: center;">
						<template slot="label">
							<i class="el-icon-mobile-phone"></i>
							手机号码
						</template>
						************
					</el-descriptions-item>
					<el-descriptions-item labelStyle="width:100px;min-width: 100px;text-align: center;">
						<template slot="label">
							<i class="el-icon-chat-square"></i>
							咨询内容
						</template>
						{{zxdata.content}}
					</el-descriptions-item>
				</el-descriptions>
			
				<div class="reply_box" v-if="zxdata.state == '1'">
					<div style="padding: 15px 0px;">回复内容：
						<div style="color:#94572C;line-height: 24px;text-indent:2em;padding: 10px 0px;">
							{{zxdata.replycontent}}
						</div>
					</div>
					<div>回复时间：{{zxdata.reviewerdatetime}}</div>
				</div>
				<div class="reply_box" v-else>
					<h4>暂未回复，请耐心等待...</h4>
				</div>
			</el-dialog>
		</div>
		<!--底部导航-->
		<bottominfo></bottominfo>
	</div>
</template>

<script>
	import headinfo from '../components/headinfo.vue'
	import bottominfo from '../components/bottominfo.vue'
	import {
		getHomeSeeConsultingList,
	} from '../api/indexapp.js';
	export default {
		name: "Bossspeak",
		components: {
			headinfo,
			bottominfo,
		},
		metaInfo: {
			title: '网上咨询-邯郸市诚信公证处',
			meta: [{
				name: 'keyWords',
				content: '网上咨询'
			}],
		},
		data() {
			return {
				pages: '1',
				tabledata:null,
				total:0,
				query:{
					pageNum: 1,
					pageSize: 10
				},
				open:false,
				zxdata:null,
			}
		},
		created() {
			this.getmsglist();
		},
		methods: {
			openzx(row){
				this.zxdata = row
				this.open = true
			},
			getmsglist(){
				getHomeSeeConsultingList(this.query).then(res=>{
					this.tabledata = res.rows
					this.total = res.total
				})
			},
			openpagesize(row){
				if(row == 1){
					this.query.pageNum = row
				}else if(row == 2){
					if(this.query.pageNum > 1){
						this.query.pageNum -= 1
					}
				}else if(row == 3){
					if(parseInt(this.total / 10 + 1) > this.query.pageNum){
						this.query.pageNum += 1
					}
				}else{
					this.query.pageNum = this.total / 10 <= 0 ? 1:parseInt(this.total / 10 + 1)
				}
				this.getmsglist();
			}
		},
	}
</script>

<style>
	@import "../assets/css/reset.css";
	@import "../assets/css/new_file.css";
</style>
